export default __webpack_public_path__ + "static/media/photo10.6554ee38.jpg";